// @flow

import React, { type Element } from 'react'
import type { UrlParams } from '../RegistrationContainer'

type FormData = {
  formId: string,
  registrationUuid: string,
  activationCode: string,
  province: string,
  category: string,
  specialityId: string,
  practitionerNumber: string,
  phoneNumber: string,
  lfpEnrolled: boolean,
  officeFacilityCode: string,
  urlParams: UrlParams,
}

const getCsrfToken = (): string => {
  const csrfTag: ?HTMLElement = document.querySelector("meta[name='csrf-token']")
  const csrfToken: ?string = csrfTag?.getAttribute('content')

  if (csrfToken === null) {
    const error = new Error('Unable to find csrf-token in the sign up page')
    window.newrelic.noticeError(error)
  }

  return csrfToken ?? ''
}

function HiddenForm({ formData }: { formData: FormData }): Element<'form'> {
  const { urlParams } = formData

  return (
    <form
      id={formData.formId}
      action="/users"
      acceptCharset="UTF-8"
      method="post"
      onSubmit={(e) => e.preventDefault()}
    >
      <input type="hidden" name="utf8" value="✓" />
      <input type="hidden" name="authenticity_token" value={getCsrfToken()} />
      <input
        type="hidden"
        name="registration_uuid"
        id="registration_uuid"
        value={formData.registrationUuid}
      />
      <input
        type="hidden"
        name="activation_code"
        id="activation_code"
        value={formData.activationCode}
      />
      <input type="hidden" name="province" id="province" value={formData.province} />
      <input
        type="hidden"
        name="sign_up_category"
        id="sign_up_category"
        value={formData.category}
      />
      <input type="hidden" name="speciality_id" id="speciality_id" value={formData.specialityId} />
      <input
        type="hidden"
        id="practitioner_num"
        name="practitioner_num"
        value={formData.practitionerNumber}
      />
      <input type="hidden" name="phone_number" id="phone_number" value={formData.phoneNumber} />
      <input type="hidden" name="lfp_enrolled" id="lfp_enrolled" value={formData.lfpEnrolled} />
      <input
        type="hidden"
        name="office_facility_code"
        id="office_facility_code"
        value={formData.officeFacilityCode}
      />
      <input type="hidden" name="promo_code" id="promo_code" defaultValue={urlParams.promoCode} />
      <input
        type="hidden"
        id="bill_share_guid"
        name="bill_share_guid"
        defaultValue={urlParams.billShareGuid}
      />
      <input
        type="hidden"
        id="bill_share_token"
        name="bill_share_token"
        defaultValue={urlParams.billShareToken}
      />
    </form>
  )
}

export default HiddenForm
